import { observer } from "mobx-react-lite";
import { Button, Modal } from "@heroui/react";
import { feedbackSettingsStore } from "@/stores/FeedbackSettingsStore";

const DeleteConfirmModal: React.FC = observer(() => {
  const { deleteTarget, isDeleting } = feedbackSettingsStore;

  return (
    <Modal.Backdrop
      isOpen={deleteTarget != null}
      onOpenChange={(open) => {
        if (!open) feedbackSettingsStore.cancelDelete();
      }}
    >
      <Modal.Container>
        <Modal.Dialog>
          <Modal.CloseTrigger />
          <Modal.Header>
            <Modal.Heading>Удалить?</Modal.Heading>
          </Modal.Header>
          <Modal.Body>
            <p className="fbs-delete-modal__text">
              {deleteTarget?.kind === "faq"
                ? "Вопрос будет удалён без возможности восстановления."
                : "Тема будет удалена без возможности восстановления."}
              {deleteTarget?.label ? (
                <>
                  <br />
                  <strong>{deleteTarget.label}</strong>
                </>
              ) : null}
            </p>
          </Modal.Body>
          <Modal.Footer className="fbs-delete-modal__footer">
            <Button
              variant="ghost"
              onPress={() => feedbackSettingsStore.cancelDelete()}
              isDisabled={isDeleting}
            >
              Отмена
            </Button>
            <Button
              variant="danger"
              onPress={() => void feedbackSettingsStore.confirmDelete()}
              isPending={isDeleting}
            >
              Удалить
            </Button>
          </Modal.Footer>
        </Modal.Dialog>
      </Modal.Container>
    </Modal.Backdrop>
  );
});

DeleteConfirmModal.displayName = "DeleteConfirmModal";
export default DeleteConfirmModal;
